import React from 'react';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {getInitialCmsPageSharedValues, PageData, useCmsData} from 'epic-ue-shared';
import Error404 from '../error/Error404';

const cmsUrlPattern = '/opt-out-confirmation';

interface Button {
    label: string;
    href: string;
}

interface OptOutPageData extends PageData {
    title: string;
    desc: string;
    primaryButton?: Button;
    secondaryButton?: Button;
}

const OptOutView = (): JSX.Element => {
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<OptOutPageData>(cmsUrlPattern);

    if (cmsLoading) {
        return (
            <div className="optout-view" key="optout-view">
                <LoadIndicator key="optout-view-loading" />
            </div>
        );
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    const {title, desc} = pageData;
    const primaryButton = pageData.primaryButton || ({} as Button);
    const secondaryButton = pageData.secondaryButton || ({} as Button);

    const primaryValid = !!(primaryButton.label && primaryButton.href);
    const secondaryValid = !!(secondaryButton.label && secondaryButton.href);

    return (
        <div id="optout-view">
            {getHelmetForMetaTags(pageData)}

            <div className="box">
                <div className="img-wrap">
                    <div className="epic-logo" />
                </div>
                <h2>{title || 'Opt Out Success'}</h2>
                <p>{desc || 'You are now unsubscribed from all Epic Games newsletters'}</p>

                <div className="buttons">
                    {primaryValid ? (
                        <a className="btn btn-primary" href={primaryButton.href}>
                            {primaryButton.label}
                        </a>
                    ) : (
                        ''
                    )}

                    {secondaryValid ? (
                        <a className="btn btn-primary" href={secondaryButton.href}>
                            {secondaryButton.label}
                        </a>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </div>
    );
};

OptOutView.getInitialSharedValues = getInitialCmsPageSharedValues(cmsUrlPattern);

export default OptOutView;
